














import { defineComponent, useContext, computed } from '@nuxtjs/composition-api';
import { SfBreadcrumbs } from '~/components/StorefrontUi';
import { STORE_URL } from '~/config/base';
import { Breadcrumb } from '~/modules/catalog/types';

export default defineComponent({
  name: 'StaticBreadcrumbs',
  components: { SfBreadcrumbs },
  props: {
    currentStory: {
      type: Object,
      default: null,
    },
  },
  setup({ currentStory }) {
    const { localePath, i18n } = useContext();

    const basicBreadcrumbs: Breadcrumb[] = [
      {
        text: `${i18n.t('Homepage')}`,
        link: localePath('/'),
      },
    ];

    const breadcrumbs = computed((): Breadcrumb[] => ([
      ...basicBreadcrumbs,
      {
        text: currentStory?.name ?? '',
        link: localePath(`/${currentStory?.full_slug}`) ?? '',
      },
    ]));

    const getBreadcrumbsSchema = () => (JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.value.map((breadcrumb, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: breadcrumb.text,
        item: `${STORE_URL}${breadcrumb.link}`,
      })),
    }));

    return {
      getBreadcrumbsSchema,
      breadcrumbs,
    };
  },
});
